import { StyleSheet } from "../../utils";

export const styles = StyleSheet({
  default: {
    borderStyle: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
  },
});
